// ORCA360 - Mobile Speaker Role Assignment
// Wraps the existing SpeakerRoleAssignmentModal in a mobile-friendly full-screen layout

import { SpeakerRoleAssignmentModal } from '../SpeakerRoleAssignmentModal';
import type { SpeakerRoleAssignment } from '../SpeakerRoleAssignmentModal';

interface MobileSpeakerRolesProps {
  sessionId: string;
  instructorId?: string;
  isOpen: boolean;
  onClose: () => void;
  onComplete: (assignments: SpeakerRoleAssignment[]) => void;
}

export default function MobileSpeakerRoles({
  sessionId,
  instructorId,
  isOpen,
  onClose,
  onComplete,
}: MobileSpeakerRolesProps) {
  // Reuse the existing modal directly — it already handles audio snippets,
  // live transcript scrolling, and role assignment logic
  return (
    <SpeakerRoleAssignmentModal
      sessionId={sessionId}
      instructorId={instructorId}
      isOpen={isOpen}
      onClose={onClose}
      onComplete={onComplete}
    />
  );
}
